var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-adv"},[_c('div',{staticClass:"content"},[_c('van-swipe',{attrs:{"autoplay":3000,"indicator-color":"white"}},_vm._l((_vm.advConfig),function(item,index){return _c('van-swipe-item',{key:index},[_c('a',{attrs:{"href":item.url}},[_c('img',{attrs:{"src":_vm._f("urlFilter")(item.img),"alt":""}})])])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }